var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("bulk-message-table", {
        ref: "table",
        attrs: {
          url: _vm.indexUrl,
          "can-create": _vm.canCreate,
          "create-url": _vm.createUrl,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }